import styled from 'styled-components';
import { padding, PaddingProps } from 'styled-system';

export const ItemsContainer = styled.div<PaddingProps>`
  ${padding};
`;
